// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5310":"81dc9a5d","5349":"5192119e","6534":"ce99d352","8735":"9371c78e"}[chunkId] + ".chunk.css";
};